module.exports = __webpack_public_path__ + "img/subtraction4.86333211.svg";